import "./header-style.css";
import logo from "../../assets/img/logo-P.png";
import { useState, useRef, useEffect } from "react";

export const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const mobileNavRef = useRef<HTMLElement>(null);
    const burgerRef = useRef<HTMLButtonElement>(null);
    const [isScrolled, setIsScrolled] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        setIsScrolled(scrollTop > 50); // меняем стиль после прокрутки на 50px
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);


    useEffect(() => {
        const handleEscape = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener("keydown", handleEscape);
        return () => document.removeEventListener("keydown", handleEscape);
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const handleLinkClick = () => {
        closeMenu();
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                mobileNavRef.current &&
                !mobileNavRef.current.contains(event.target as Node) &&
                burgerRef.current &&
                !burgerRef.current.contains(event.target as Node)
            ) {
                closeMenu();
            }
        };

        if (isMenuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <header className={`Header ${isScrolled ? 'fixed' : ''}`}>
            <div className="container header-inner">
                {/* Логотип */}
                <a href="/" className="logo" aria-label="Вау... Праздник!!!">
                    <img
                        className="header__logo"
                        src={logo}
                        alt="Логотип компании 'Вау... Праздник!!!'"
                    />
                    <span className="visually-hidden">Вау... Праздник!!!</span>
                </a>

                {/* Основная навигация (видима на десктопе) */}
                <nav className="main-nav" aria-label="Основная навигация">
                    <ul>
                        <li><a href="/#party" onClick={handleLinkClick} className={`link ${isScrolled ? 'add-color-scroll' : ''}`}>Вечеринки</a></li>
                        <li><a href="/#gallery" onClick={handleLinkClick} className={`link ${isScrolled ? 'add-color-scroll' : ''}`}>Галерея</a></li>
                        <li><a href="/#reviews" onClick={handleLinkClick} className={`link ${isScrolled ? 'add-color-scroll' : ''}`}>Отзывы</a></li>
                        <li><a href="/#faq" onClick={handleLinkClick} className={`link ${isScrolled ? 'add-color-scroll' : ''}`}>FAQ</a></li>
                        <li><a href="/#order" onClick={handleLinkClick} className={`link ${isScrolled ? 'add-color-scroll' : ''}`}>Заказать</a></li>
                    </ul>
                </nav>
                <div className="header-actions">
                    <a className="phone" href="tel:+79642936313">
                        +7 (964) 293-63-13
                    </a>
                </div>
                <button
                    className={`burger-menu ${isMenuOpen ? 'open' : ''}`}
                    onClick={toggleMenu}
                    aria-label={isMenuOpen ? "Закрыть меню" : "Открыть меню"}
                    aria-expanded={isMenuOpen}
                    type="button"
                    ref={burgerRef}>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
            {isMenuOpen && (
                <nav
                    className="nav__mobile open"
                    aria-label="Мобильная навигация"
                    ref={mobileNavRef}
                >
                    <div className="nav__mobile-content">
                        <ul>
                            <li><a href="/#party" onClick={handleLinkClick}>Вечеринки</a></li>
                            <li><a href="/#gallery" onClick={handleLinkClick}>Галерея</a></li>
                            <li><a href="/#reviews" onClick={handleLinkClick}>Отзывы</a></li>
                            <li><a href="/#faq" onClick={handleLinkClick}>FAQ</a></li>
                            <li><a href="/#order" onClick={handleLinkClick}>Заказать</a></li>
                        </ul>
                        <div className="header-actions">
                            <a className="phone" href="tel:+79642936313">
                                +7 (964) 293-63-13
                            </a>
                        </div>
                    </div>
                </nav>
            )}
        </header>
    );
};
